const calculateNumberOfDays = (initDate, endDate) => {
    return endDate.startOf('day').diff(initDate.startOf('day'), 'days');
};

export default calculateNumberOfDays;


// WEBPACK FOOTER //
// ./src/utils/calculateNumberOfDays.js